import api from '@pray/shared/utils/api';

import type { SeedListEnvelope, SeedProvider, SeededFilter, SeedSourceValue } from './types';

const SEEDS_URL = '/web/studio/admin/seed-emails/seeds';

export type GetSeedsParams = {
  q?: string;
  isp?: SeedProvider | '';
  source?: SeedSourceValue | '';
  groupId?: string;
  seeded?: SeededFilter | '';
  sortColumn?: 'email' | 'last_seeded_at' | 'created_at';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
};

/**
 * The seeds list, its unfiltered stats and its facet counts in one call.
 *
 * The envelope is unwrapped here rather than in an interceptor: sibling services return the raw
 * envelope, and a global unwrap would break them. This list needs more than `data`, so the whole
 * envelope is kept and the caller's mapper reshapes it.
 */
export async function getSeeds({
  q,
  isp,
  source,
  groupId,
  seeded,
  sortColumn = 'email',
  sortDirection = 'asc',
  limit = 15,
  offset = 0,
}: GetSeedsParams = {}) {
  const params: Record<string, string | number> = {
    sort_column: sortColumn,
    sort_direction: sortDirection,
    limit,
    offset,
  };
  // Empty filters are left out entirely: the schema accepts the parameter or rejects the request,
  // and `isp=` is not a valid ISP.
  if (q) params.q = q;
  if (isp) params.isp = isp;
  if (source) params.source = source;
  if (groupId) params.group_id = groupId;
  if (seeded) params.seeded = seeded;

  const res = await api.executeGetRequest<SeedListEnvelope>(SEEDS_URL, params);
  return res.data;
}
